export { createLocationSearchFromState } from './create-location-search-from-state';
